import React, { Component } from "react";
import moment from "moment";
import { map, uniq } from "lodash";
import { formatDuration } from "components/utils/fetchHook";
import ReadingSubTypeSummary from "./ReadingSubTypeSummary";
import male from "../../files/male-placeholder.png";
import female from "../../files/woman-placeholder.png";
import CCMQuestionaire from "./CCMQuestionaire";
import SessionNotes from "./SessionNotes";
import readingSubTypes from "store/reducers/readingSubType.json";
import CCMNotesWithSignature from "./CCMNotesWithSignature";
import RPMNotesWithSignature from "./RPMNotesWithSignature";
import CCMForm from "../CCMForm/CCMForm";
import CPTCodeList from "./CPTCodeList";
import EducationMaterialDetails from "./EducationMaterialDetails";
import "./CCMinterventionContainer.css";

export default class CCMinterventionContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "1"
    };
  }
  componentDidMount() {}
  render() {
    const {
      start,
      end,
      profile,
      totalSessionCCM,
      totalSessionRPM,
      violations,
      expectation,
      // noteIntervention,
      ccmAnswers,
      readings,
      bodytraceReading,
      lastReadingDate,
      onBoardingNotes,
      rpmMode,
      ccmMode,      
      onRPMBoardingNotes,
      ccmFormSubmission,
      isBloodPressureReading,
      CPTCodeDetails,
      educationMaterials,
      carePlanDiagnosis
    } = this.props.responseData;
    const getDevice = map(profile.devices, "device");
    const getDeviceType = map(getDevice, "deviceType");
    const getDeviceTypeName = map(getDeviceType, "description");
    const getUniqNameDevice = uniq(getDeviceTypeName);
    const image = this.props.patient.gender === "Male" || this.props.patient.gender === "M" ? male : female;
    document.title = "Patient Management Session Report";
    return (
      <div id="exportToImageIntervention">
        <h4 className="text-center"></h4>
        <h3 class="text-center">
         Patient Management Session Report
        </h3>
        <h4 class="text-center">
          <span id="dateRange">
            Date Range: {moment(start).format("MM/DD/YYYY")} -{" "}
            {moment(end).format("MM/DD/YYYY")}
          </span>
        </h4>
        <div class="card card-design-session-popup">
          <div class="card-body card-body-design-session-popup" style={{ padding: 5 }}>
            <div class="card-title patient-info-wrapper">
              <div class="patient-header-card">
                <div class="patient-profile-section">
                  <div class="profile-image-container">
                    <img
                      src={image}
                      alt="profile-image"
                      className="patient-profile-image"
                    />
                  </div>
                  <div class="patient-name-section">
                    <h2 className="patient-name-heading">
                      <span id="patientName" className="patient-name">
                        {this.props.patient.fname} {this.props.patient.lname}                      
                      </span>
                    </h2>
                  </div>
                </div>
              </div>
              
              <div class="patient-details-card">
                <div class="patient-details-grid">
                  <div class="detail-item">
                    <div class="detail-icon">
                      <i className="mdi mdi-account-star"></i>
                    </div>
                    <div class="detail-content">
                      <span class="detail-label">Nickname</span>
                      <span class="detail-value"> 
                        {this.props.patient.nickname ? this.props.patient.nickname : '-'}
                      </span>
                    </div>
                  </div>
                  
                  <div class="detail-item">
                    <div class="detail-icon">
                      <i className="mdi mdi-calendar"></i>
                    </div>
                    <div class="detail-content">
                      <span class="detail-label">Date of Birth</span>
                      <span class="detail-value"> 
                        {moment(this.props.patient.bday).format("MMMM DD, YYYY")}
                      </span>
                    </div>
                  </div>
                  
                  <div class="detail-item">
                    <div class="detail-icon">
                      <i className="mdi mdi-clock-outline"></i>
                    </div>
                    <div class="detail-content">
                      <span class="detail-label">Last Reading Date</span>
                      <span class="detail-value"> 
                        {lastReadingDate ? moment(lastReadingDate).format("MMMM DD, YYYY") : 'NONE'}
                      </span>
                    </div>
                  </div>
                  
                  <div class="detail-item full-width">
                    <div class="detail-icon">
                      <i className="mdi mdi-devices"></i>
                    </div>
                    <div class="detail-content">
                      <span class="detail-label">Devices</span>
                      <span class="detail-value devices-value">
                        {getUniqNameDevice.join(", ")}
                      </span>
                    </div>
                  </div>

                  {carePlanDiagnosis && (
                    <>
                      <div class="detail-item full-width">
                        <div class="detail-icon">
                          <i className="mdi mdi-stethoscope"></i>
                        </div>
                        <div class="detail-content">
                          <span class="detail-label">Primary Diagnosis</span>
                          <span class="detail-value">
                            {carePlanDiagnosis.primaryDiagnosis || '-'}
                          </span>
                        </div>
                      </div>

                      <div class="detail-item full-width">
                        <div class="detail-icon">
                          <i className="mdi mdi-clipboard-pulse-outline"></i>
                        </div>
                        <div class="detail-content">
                          <span class="detail-label">ICD-10 Diagnosis Codes</span>
                          {carePlanDiagnosis.icdCodes.length > 0 ? (
                            carePlanDiagnosis.icdCodes.map((icd, index) => (
                              <span key={index} class="detail-value">
                                {icd.code}{icd.label ? ` - ${icd.label}` : ""} ({icd.category})
                              </span>
                            ))
                          ) : (
                            <span class="detail-value">-</span>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {ccmFormSubmission && (
              <>
                <hr style={{ borderTop: "3px solid #5c5959" }} />
                <h3 className="text-center font-weight-bold">
                  <div>
                    CCM CARE PLAN FORM
                  </div>
                </h3>
                <hr style={{ borderTop: "1px solid #dedede" }} />
                <div>
                  <div class="card-title row">
                    <div class="col-6">
                      <div class="col-12" style={{ textAlign: "start" }}>
                        <span class="text-dark" style={{ fontSize: 15, fontWeight:500 }}><i className="mdi mdi-clock" /> Created Date  : </span>
                        <span id="patientBday">{ccmFormSubmission ? moment(ccmFormSubmission.createdDate).format("MMMM DD, YYYY HH:mm:ss") : '-'}</span>
                      </div>
                      <div class="col-12" style={{ textAlign: "start" }}>
                        <span class="text-dark" style={{ fontSize: 15, fontWeight:500 }}><i className="mdi mdi-clock" /> Modified Date: </span>
                        <span id="patientBday">{ccmFormSubmission && ccmFormSubmission.modifyDate ? moment(ccmFormSubmission.modifyDate).format("MMMM DD, YYYY HH:mm:ss") : '-'}</span>
                      </div>
                    </div>                    
                  </div>
                </div>
                <CCMForm
                  isEditable={false}
                  isAttestationPrint={true}
                  latestSubmission={ccmFormSubmission.submission}
                  profile={profile}
                  submisionModel={ccmFormSubmission}
                />
                <hr style={{ borderTop: "3px solid #5c5959" }} />
              </>
            )}
            {onRPMBoardingNotes != undefined && onRPMBoardingNotes.length>0 && (
              <>
                <RPMNotesWithSignature
                  onBoardingNotes={onRPMBoardingNotes}
                  profile={profile}
                />
              </>
            )}
            {onBoardingNotes != undefined && onBoardingNotes.length>0 && (
              <>
                <CCMNotesWithSignature
                  onBoardingNotes={onBoardingNotes}
                  profile={profile}
                />
              </>
            )}
            {ccmAnswers.ccmAnswers != undefined && ccmAnswers.ccmAnswers.length>0 && (
              <>
              <CCMQuestionaire 
              ccmAnswers={ccmAnswers.ccmAnswers}
              ccmModel={ccmAnswers.ccmNewAnswers}
              profile={profile}
              />
              </>
            )}            
            {totalSessionCCM != "00:00:00" && (
              <>                
                <SessionNotes
                  notes={ccmMode}
                  pmMode={"CCM MODE"}
                  pmModeTotal={formatDuration(totalSessionCCM)}
                />
              </>
            )}
            {totalSessionRPM != "00:00:00" && (
              <SessionNotes
                notes={rpmMode}
                pmMode={"RPM MODE"}
                pmModeTotal={formatDuration(totalSessionRPM)}
              />
            )}

            <br />
            <ReadingSubTypeSummary
              profileOwner={this.props.profileOwner}
              profile={profile}
              violations={violations}
              expectation={expectation}
              start={start}
              readings={readings}
              bodytraceReading={bodytraceReading}
              readingSubTypes={readingSubTypes}
              dateRange={`${moment(start).format("MM/DD/YYYY")} - ${moment(
                end
              ).format("MM/DD/YYYY")}`}
              isBloodPressureReading={isBloodPressureReading}
            />

            <CPTCodeList
            CPTCodeDetails={CPTCodeDetails}
            rpmMode={rpmMode}
            totalSessionRPM={formatDuration(totalSessionRPM)}
            ccmMode={ccmMode}
            totalSessionCCM={formatDuration(totalSessionCCM)}
            />
            
            {/* education material details */}
            {educationMaterials && educationMaterials.length > 0 && (
              <div style={{overflowX : 'auto'}}>
                <EducationMaterialDetails educationMaterials={educationMaterials} />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

